<script setup>
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";

const CARD_INPUT_STYLE = {
  base: {
    color: '#000000',
    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
    fontSmoothing: 'antialiased',
    fontSize: '16px',
    '::placeholder': {
      color: '#343a40',
    }
  },
  invalid: {
    color: '#eb1c26',
    iconColor: '#eb1c26',
  }
}

defineProps({
  showNotice: {
    type: Boolean,
    required: false,
    default: true,
  },
  textCenter: {
    type: Boolean,
    required: false,
    default: true,
  },
});

const store = useStore();

const cardElement = ref(null);
const cardError = computed(() => store.getters['billing/cardError']);

onMounted(async () => {
  store.dispatch('billing/createCardElement', {
    element: cardElement.value,
    options: {
      style: CARD_INPUT_STYLE,
    }
  });
})
</script>

<template>
  <div>
    <div
      class="card-container"
    >
      <div ref="cardElement" />
    </div>

    <div
      v-if="cardError"
      class="xs-mt-5 font-size-16 card-error"
      :class="{
        'text-center': textCenter,
      }"
      role="alert"
      v-html="cardError"
    />

    <p v-if="showNotice">
      <em><strong>Please note,</strong> this payment method will also be used for future payments.</em>
    </p>
  </div>
</template>

<style scoped>
  .card-container {
    border: 2px solid #e3e2e2;
    padding: 18px 10px;
  }

  .card-error {
    color:#eb1c26;
  }
</style>
